import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import {
	Container,
	ContentSection,
	ContentWrapper,
	PageTabNavigation,
} from '@pangea-lis-apps/ui';

import PatientDetails from './details';
import PatientReports from './reports';
// import { GATrackEvent } from 'apps/customer-portal/src/app/shared/googleAnalitycs';

const tabs = [
	{ label: 'Details', value: 'details', show: true },
	{ label: 'Reports', value: 'reports', show: true },
];

/* eslint-disable-next-line */
export interface ViewPatientProps {}

export default function ViewPatient(props: ViewPatientProps) {
	const [searchParams] = useSearchParams();
	const tab = searchParams.get('tab');

	const [currentTab, setCurrentTab] = useState(tab ? tab : 'details');

	const handleTabChange: React.Dispatch<React.SetStateAction<string>> = (
		newTabOrFn
	) => {
		const newTab =
			typeof newTabOrFn === 'function'
				? newTabOrFn(currentTab)
				: newTabOrFn;

		setCurrentTab(newTab);

		// GATrackEvent({
		// 	eventName: 'patient_tab_click',
		// 	params: {
		// 		location: 'view_patient_page',
		// 		context: 'tab_navigation',
		// 		method: 'click_tab',
		// 		item: newTab,
		// 	},
		// });
	};

	return (
		<Container>
			<ContentWrapper Icon="UserIcon" heading="Patient Information">
				<ContentSection>
					<PageTabNavigation
						tabs={tabs}
						currentTab={currentTab}
						setCurrentTab={handleTabChange}
					/>
				</ContentSection>
				{currentTab === 'details' && <PatientDetails />}
				{currentTab === 'reports' && <PatientReports />}
			</ContentWrapper>
		</Container>
	);
}
